import { render, staticRenderFns } from "./modalProductos.vue?vue&type=template&id=10177494&scoped=true&"
import script from "./modalProductos.vue?vue&type=script&lang=js&"
export * from "./modalProductos.vue?vue&type=script&lang=js&"
import style0 from "./modalProductos.vue?vue&type=style&index=0&id=10177494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10177494",
  null
  
)

export default component.exports